<script lang="ts">
	export let post;

	export let showExcerpt = false;

	$: date = new Date(post.date);
</script>

<div class="post-info">
	<span class="stats">
		<span class="date">{date.toLocaleDateString()}</span>
	</span>

	<slot name="title">
		<h3 class="title truncate lines-3">
			{@html post.title.rendered}
		</h3>
	</slot>

	{#if post.excerpt.rendered && showExcerpt}
		<p class="excerpt truncate lines-4">
			{@html post.excerpt.rendered}
		</p>
	{/if}
</div>

<style lang="postcss">
	.post-info {
		display: grid;
		gap: 0.5rem 0;
		place-items: start;

		& :global(.badge) {
			margin-bottom: 0.25rem;
		}
	}

	.stats {
		color: hsla(var(--hsl-gray));
		font: var(--f-ui-sm-medium);
	}

	.title {
		font: var(--f-heading-sm-bold);

		@media (width > 767px) {
			font: var(--f-heading-lg-bold);
		}
	}

	.excerpt {
		color: hsla(var(--hsl-gray-dark));
		font: var(--f-paragraph-sm-medium);

		@media (width <= 480px) {
			display: none;
		}
	}
</style>
